// extracted by mini-css-extract-plugin
module.exports = {"large":"LargeCard_large__tedKQ","heading":"LargeCard_heading__f1Vtm","body":"LargeCard_body__bFDKG"};